import "../styles/default.scss";

import classNames from "classnames";
import moment from "moment-mini";
import React from "react";
import { compose } from "redux";

import { UrlProvider } from "../../../../../api/UrlProvider";
import withAnalysisCategories from "../../../../../hocs/withAnalysisCategories";
import withHistoryListItemAccessHandler from "../../../../../hocs/withHistoryListItemAccessHandler";
import withUserData from "../../../../../hocs/withUserData";
import useMobileMediaQuery from "../../../../hooks/useMobileMediaQuery";
import ContentSection from "../../ContentSection";
import SimpleAlertButton from "../../SimpleAlertButton/modules/default";
import SquaberButton from "../../SquaberButton";
import SquaberTooltip from "../../SquaberTooltip";
import { AdapterSquaberLink } from "../../SquaberLink/modules/default";
import { shouldLimitAccess } from "../../SquaberCommentsListItem/utils/shouldLimitAccess";
import { shouldShowContent as getShouldShowContent } from "../../SquaberCommentsListItem/utils/shouldShowContent";

const SquaberCommentsRowItem = ({
  translate,
  stock: { ticker, market, name: stock_name, id: stockId },
  author,
  active,
  created,
  publication_date,
  updated,
  handleDescriptionButtonClick,
  locale,
  id,
  category,
  content,
  analysisCategories,
  permissions,
  isInsiderAnalysis,
  hasPermission
}) => {
  const publishedAt = publication_date;
  const isMobile = useMobileMediaQuery();
  const commentCategory = analysisCategories.find(cat => cat.id === category);

  const limitedAccess = shouldLimitAccess({ active, content });
  const shouldShowContent = getShouldShowContent({
    active,
    content,
    hasPermission,
    permissions
  });

  const analysisUrl = isInsiderAnalysis
    ? UrlProvider.getLocalizedUrl(locale, "fe.singleInsiderAnalysisPage", {
        locale,
        id
      })
    : UrlProvider.getLocalizedUrl(locale, "fe.singleAnalysisPage", {
        locale,
        id
      });

  return (
    <ContentSection className="squaber-comments-row-item">
      <SimpleAlertButton stockId={stockId} />
      <AdapterSquaberLink
        to={UrlProvider.getUrl("fe.stockPage", {
          locale,
          marketId: market,
          stockId: ticker
        })}
        className="squaber-comments-row-item__ticker-wrapper"
      >
        <SquaberTooltip title={ticker}>
          <h2 className="squaber-comments-row-item__ticker">{ticker}</h2>
        </SquaberTooltip>
        <span className="squaber-comments-row-item__market">{market}</span>
      </AdapterSquaberLink>

      <SquaberTooltip title={stock_name}>
        <p className="squaber-comments-row-item__stock-name">{stock_name}</p>
      </SquaberTooltip>
      <SquaberTooltip title={commentCategory?.name ?? ""}>
        <p className="squaber-comments-row-item__secondary-text squaber-comments-row-item__ellipsis">
          {commentCategory?.name}
        </p>
      </SquaberTooltip>
      <div className="squaber-comments-row-item__secondary-text">
        {isMobile ? null : `${translate("Created on")}: `}
        {moment(publishedAt).format("DD.MM.YYYY, HH:mm")}
        {updated !== created ? (
          <SquaberTooltip
            title={`${translate("Updated on")}: ${moment(updated).format(
              "DD.MM.YYYY HH:mm"
            )}`}
          >
            <span>
              {" "}
              <i className="fal fa-info-circle" />
            </span>
          </SquaberTooltip>
        ) : null}
      </div>
      <div className="squaber-comments-row-item__secondary-text">
        {isMobile ? " " : `${translate("Status")} `}
        <span
          className={classNames({
            "squaber-comments-row-item__signal_active": active,
            "squaber-comments-row-item__signal_inactive": !active
          })}
        >
          {translate(`signal_status_${active ? "active" : "inactive"}`)}
        </span>
      </div>
      {author.first_name && author.last_name ? (
        <SquaberTooltip
          title={`${translate("Author")}: ${author.first_name} ${
            author.last_name
          }`}
        >
          <p className="squaber-comments-row-item__secondary-text squaber-comments-row-item__author">
            {isMobile ? "" : `${translate("Author")}: `}
            {author.first_name}&nbsp;{author.last_name}
          </p>
        </SquaberTooltip>
      ) : (
        <span />
      )}
      <div className={"squaber-comments-row-item__buttons-wrapper"}>
        {isMobile && !shouldShowContent ? (
          <SquaberTooltip
            onClick={e => e.preventDefault()}
            title={"squaber-comments_no-permission_tooltip"}
          >
            <span>
              <i className="fal fa-info-circle" />
            </span>
          </SquaberTooltip>
        ) : null}
        <SquaberTooltip
          title={
            !shouldShowContent ? "squaber-comments_no-permission_tooltip" : ""
          }
        >
          <AdapterSquaberLink
            to={shouldShowContent ? analysisUrl : "#!"}
            onClick={event => {
              handleDescriptionButtonClick(
                hasAccess => {
                  if (!hasAccess) {
                    event.preventDefault();
                  }
                },
                limitedAccess,
                permissions
              );
            }}
          >
            <SquaberButton color="primary_small" disabled={!shouldShowContent}>
              {translate("Description")}
            </SquaberButton>
          </AdapterSquaberLink>
        </SquaberTooltip>
      </div>
    </ContentSection>
  );
};

export default compose(
  withHistoryListItemAccessHandler,
  withUserData,
  withAnalysisCategories
)(SquaberCommentsRowItem);
